import { computed } from 'vue';
import { LAYOUT_TYPE, type LayoutType } from '@/constants';
import { useProjectStore } from '@/store/project';
import { useViewportAccessGate } from '@/hooks/useViewportAccessGate';

/** 需要以横屏双页阅读的版式。 */
export const isLandscapeDoublePageLayout = (layout: LayoutType | '') =>
  layout === LAYOUT_TYPE.FULL_SCREEN ||
  layout === LAYOUT_TYPE.TEXT_IMAGE_34 ||
  layout === LAYOUT_TYPE.CROSS_PAGE_11 ||
  layout === LAYOUT_TYPE.IMAGE_TEXT_11;

/** 阅读端横屏双页版式的逻辑横屏状态；项目约定 !isPC 即按移动端处理。 */
export const useReaderLandscape = () => {
  const projectStore = useProjectStore();
  const { isPC, isLandscape, isPortrait } = useViewportAccessGate();

  const shouldForceLandscape = computed(
    () => !isPC.value && isLandscapeDoublePageLayout(projectStore.layout)
  );
  const shouldRotateReader = computed(() => shouldForceLandscape.value && isPortrait.value);

  return {
    isPC,
    isLandscape,
    isPortrait,
    shouldForceLandscape,
    shouldRotateReader
  };
};
